import { config } from "@/app/config";
import { LanguageKey, Storage } from "@/shared/common/enums";
import { getFromLocalStorage } from "@/shared/helpers";
import i18n from "i18next";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const fallbackLng = getFromLocalStorage(Storage.Lang) || LanguageKey.Hy;

void i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng,
    supportedLngs: ["en", "hy", "ru"],
    ns: ["translation"],
    defaultNS: "translation",
    load: "languageOnly",
    debug: false,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${config.cloudflareLocalizationUrl}/{{lng}}.json`
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
